import React from 'react';
import { withPrefix } from 'gatsby';
import styled from 'styled-components';
import { useGlobalState } from '~app/state';

const MonumentArtStyles = styled.div`
	// height: 100vh;
	// width: calc(100vw - 500px);
	// position: relative;

	.monument__bg {
		background-size: cover;
	    background-position: center center;
	    height: 100%;
	    width: 100%;

	@media (max-width: 768px) {
		display: none;
	}
`;

const MonumentArt = ({selectedMonument}) => {
	const imagepath = withPrefix(`images/main_${selectedMonument}.jpg`);

	return (
		<MonumentArtStyles>
			<div
			   className="monument__bg"
			   style={{
			   	backgroundImage: `url(${imagepath})`,
			   }}
			/>
		</MonumentArtStyles>
	);
};

export default MonumentArt;
